export type TestIds = {
  dataTestId?: string
  dataTrackingId?: string
}

export const getTestProps = ({ dataTestId, dataTrackingId }: TestIds) => ({
  'data-testid': dataTestId,
  'data-tracking-id': dataTrackingId,
})
